import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { AUTH_SERVICE_URL, AUTH_API } from '../../helper/constant'



export const UPLOAD_FILES_FOR_DOCUMENT = (payload) => async (dispatch) => {
  try {
      const formData = new FormData();

      for (let key in payload) {
        if (payload.hasOwnProperty(key)) {
          if (payload[key] instanceof File || Array.isArray(payload[key])) {
            if (Array.isArray(payload[key])) {
              payload[key].forEach(file => formData.append(key, file));
            } else {
              formData.append(key, payload[key]);
            }
          } else {
            formData.append(key, payload[key]);
          }
        }
      }
   const data = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${AUTH_API.INQUIRY}/uploadFile`, formData,
   {
     headers: {
       'Content-Type': 'multipart/form-data',
     },
   });
   return data?.data
  } catch (exception) {
    dispatch({
      type: Types.UPLOAD_FILE_ERROR,
      error:exception.message
    })
  }
}

export const UPLOAD_GUEST_FILES_FOR_DOCUMENT = (payload) => async (dispatch) => {
  try {
    const formData = new FormData();

    for (let key in payload) {
      if (!payload.hasOwnProperty(key)) continue;
      const value = payload[key];
      if (!(value instanceof File) && !Array.isArray(value)) {
        formData.append(key, value);
      }
    }
    for (let key in payload) {
      if (!payload.hasOwnProperty(key)) continue;
      const value = payload[key];
      if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        value.forEach(file => formData.append(key, file));
      }
    }

    const data = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${AUTH_API.INQUIRY}/uploadGuestFile`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data?.data;
  } catch (exception) {
    dispatch({
      type: Types.UPLOAD_FILE_ERROR,
      error: exception.message,
    });
  }
}

export const UPLOAD_FILES_FOR_INQUIRY_COMMENT = (payload) => async (dispatch) => {
  try {
    const formData = new FormData();

    for (let key in payload) {
      if (payload.hasOwnProperty(key)) {
        if (key === 'files' && Array.isArray(payload[key])) {
          payload[key].forEach(file => formData.append('files', file));
        } else {
          formData.append(key, payload[key]);
        }
      }
    }

    const data = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}${AUTH_API.INQUIRY}/uploadFileComment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data?.data?.data;
  } catch (exception) {
    dispatch({
      type: Types.UPLOAD_FILE_ERROR,
      error: exception.message,
    });
  }
};